import AOS from 'aos';

export default function ScrollAnimation($DOM, classes) {
	AOS.init();
}